export const headers = {
    code: "Code",
    expenseName: "Expense Name",
    category: "Product/Service Category",
    glCode: "GL Code",
    gst: "GST %",
    tds: "TDS %",
    edit: "Edit",
}